// Generic horizontal container for filter controls.
export function FilterBar({ children }) {
  return (
    <div className="relative z-20 flex flex-wrap items-end gap-4 bg-white/60 dark:bg-slate-900/60 backdrop-blur-xl rounded-xl ring-1 ring-white/40 dark:ring-white/10 border border-white/50 dark:border-white/10 p-4">
      {children}
    </div>
  );
}
